import request from '@/common/request'

class CFOPService {
  getAll() {
    return request.get('/cfops')
  }

  create(data) {
    return request.post('/cfops', data)
  }

  update(id, data) {
    return request.patch(`/cfops/${id}`, data)
  }

  deleteById(id) {
    return request.delete(`/cfops/${id}`)
  }
}

export default new CFOPService()
